import { Button, Cascader, Input } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import './index.less';
import { compareTreeData } from '@/common/utils/helper/compare-tree-data';

export default function Category({ value, onChange, option }) {
  const [_label, set_Label] = useState('');
  const [_value, set_Value] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!value) {
      set_Label('');
      set_Value([]);
    } else {
      set_Label(value.label);
      set_Value(compareTreeData(option, value.value));
    }
  }, [value, option]);
  const dropdownRender = (menus) => {
    return (
      <div>
        <div>{menus}</div>
        <div className="product-plan-category-panel-operate">
          <Input
            value={_label}
            placeholder="请自定义名称，最多10个字"
            onChange={(e) => {
              set_Label(e.target.value);
            }}
          />
          <Button
            onClick={(e) => {
              setOpen(false);
            }}
            style={{ margin: '0 10px' }}
          >
            取消
          </Button>
          <Button
            disabled={!_label || !_value?.length}
            type="primary"
            onClick={() => {
              onChange({ label: _label, value: getChildNode(_value, option) });
              setOpen(false);
            }}
          >
            确定
          </Button>
        </div>
      </div>
    );
  };
  return (
    <Cascader
      allowClear={false}
      className="sub-plan-pinlei-input"
      placeholder="请选择"
      style={{ width: 128 }}
      maxTagCount={1}
      maxTagPlaceholder={null}
      tagRender={() => <span className="ellipsis-1-line">{_label}</span>}
      onFocus={() => setOpen(true)}
      open={open}
      expandTrigger="hover"
      dropdownClassName="sub-plan-pinlei-panel"
      multiple
      options={option}
      value={_value}
      fieldNames={{ value: 'value', label: 'name' }}
      dropdownRender={dropdownRender}
      onChange={(value, a) => {
        set_Value(value);
      }}
    />
  );
}

function getChildNode(value = [], option = []) {
  let nodes = [];
  if (!value.length || !option.length) return nodes;
  value.map((item) => {
    let child = option;
    // 找到value中的末级节点
    item.map((ele) => {
      let _child = child.filter((value) => value.value == ele)[0];
      if (_child && _child.children && _child.children.length) {
        child = _child.children;
      } else {
        // 找不到或者没有子节点，就算最末级
        nodes.push(ele);
      }
    });
    if (Array.isArray(child) && child.length > 0) {
      findNode(child);
    } else {
      nodes.push(child);
    }
  });

  function findNode(child = []) {
    child.map((item) => {
      if (item.children && item.children.length) {
        findNode(item.children);
      } else {
        nodes.push(item.value);
      }
    });
  }
  return nodes;
}
